import { TrackingHandler } from '../TrackingHandler';
import { Listener } from './Listener';
export class SessionStorageListener extends Listener {
    cookiesAccepted = false;
    visitTimestamp;
    constructor() {
        super();
        this.visitTimestamp = window.sessionStorage.getItem('visitTimestamp')
            ? parseInt(window.sessionStorage.getItem('visitTimestamp'))
            : window.trackingHandler.viewTimestamp;
    }
    setConsent(essential, functional, marketing) {
        if (!functional && this.cookiesAccepted) {
            this.clearSessionStorage();
        }
        if (functional && !this.cookiesAccepted) {
            this.persistSessionStorage();
        }
        this.cookiesAccepted = functional;
    }
    clearSessionStorage() {
        window.sessionStorage.clear();
    }
    persistSessionStorage() {
        const trackingHandler = TrackingHandler.getInstance();
        window.sessionStorage.setItem('trackingData', JSON.stringify(trackingHandler.getSessionTrackingData()));
        window.sessionStorage.setItem('visitTimestamp', this.visitTimestamp.toString());
    }
}
